export default [
    {
        comment: '',
        error_id: 'CEC-01',
        data: [
            {cross_section: '4400', number: '1', bridge: '4450', exp: '0.8', cont: '0.9', type: 'Bridge'},
            {cross_section: '4500', number: '1', culvert: '4550', exp: '0.8', cont: '0.9', type: 'Culvert'},
        ]
    },
    {
        comment: 'use . instead of : at the end of the sentence',
        error_id: 'CEC-02',
        data: [
            {cross_section: '4400'},
            {cross_section: '4500'},
        ]
    }
]